<template>
    <div id="shop" v-wechat-title="this.title">
       <div class="nav">
         <ul>
             <li @click="sortSwitch(0)">最热</li>
             <li @click="sortSwitch(1)">最新</li>
             <li @click="sortSwitch(2)">价格<span :class="priceSort==0?'active':(priceSort==1?'active1':'active2')"></span></li>
         </ul>
       </div>

        <Row :gutter="24">
            <Col span="8" v-for="(product, key) in productList" :key="key">
               <div class="product"  @click="payDetail(product.id)">
                   <div class="p_dv">
                       <img :src="product.entity_image">
                       <div class="p_title">{{ product.entity_name}}</div>
                   </div>
                   <div style="width:100%;margin-top:8px;overflow: hidden">
                       <div class="p_sellnum">销量{{ product.sale}}</div>
                       <div class="p_oprice">￥{{ product.price}}</div>
                       <div class="p_price">￥{{ product.old_price}}</div>
                   </div>
               </div>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: "Shop",
        data () {
            return {
                title: '商品列表',
                index: 0,
                priceSort: 0,

            }
        },
        methods:{
            sortSwitch(num){
                this.$LoadingBar.start();
                this.index = num;
                let data = {};
                switch (num) {
                    case 0:
                        data['hot']= 1;
                        this.priceSort =0;
                        this.$store.dispatch('shopList',data).then(()=>{
                            this.$LoadingBar.finish();
                        });
                        break;
                    case 1:
                        data['new'] = 1;
                        this.priceSort =0;
                        this.$store.dispatch('shopList',data).then(()=>{
                            this.$LoadingBar.finish();
                        });
                        break;
                    case 2:
                        if(this.priceSort == 0){
                            this.priceSort =1;
                            data['priceSort'] = 1;
                            this.$store.dispatch('shopList',data).then(()=>{
                                this.$LoadingBar.finish();
                            });
                        }else if(this.priceSort ==1){
                            this.priceSort =2;
                            data['priceSort'] = 2;
                            this.$store.dispatch('shopList',data).then(()=>{
                                this.$LoadingBar.finish();
                            });
                        }else if(this.priceSort ==2){
                            this.priceSort =1;
                            data['priceSort'] = 1;
                            this.$store.dispatch('shopList',data).then(()=>{
                                this.$LoadingBar.finish();
                            });
                        }
                        break;
                }
            },
            payDetail(id){
                this.$router.push({'path':'/payment','query':{pid:id}});
            }
        },
        mounted(){
            let data = {};
            this.$store.dispatch('shopList',data).then(()=>{
                setTimeout(() => {
                    this.$LoadingBar.finish();
                }, 500);
            });
        },
        computed : {
            productList(){
                return this.$store.getters.getShopList;
            }
        }
    }
</script>

<style scoped>
    #shop{
        background: #F1F2F5;
        width: 100%;
        overflow: hidden;
        padding: 0 15%;
    }
    .nav{
        width: 100%;
        text-align: left;
        padding: 15px 0;
    }
    .nav ul{
        overflow: hidden;
    }
    .nav li{
        display: inline-block;
        float: left;
        margin: 0 5px;
        cursor: pointer;
        position: relative;
    }
    .active{
        width: 12px;
        height: 12px;
        background: url("/images/sort.png") no-repeat;
        float: right;
        margin: 5px 0 0 4px;
    }
    .active1{
        width: 12px;
        height: 12px;
        background: url("/images/sort.png") no-repeat 0px -15px;;
        float: right;
        margin: 5px 0 0 4px;
    }
    .active2{
        width: 12px;
        height: 12px;
        background: url("/images/sort.png") no-repeat 0px -29px;
        float: right;
        margin: 5px 0 0 4px;
    }
    .product{
        margin: 20px 0;
        padding: 20px 15px;
        background: #fff;
    }
    .product img{
        width: 80%;
        margin-left: 10%;
    }
    .p_dv{
        width: 100%;
        height: 300px;
    }
    .p_title{
        margin-top: 20px;
        font-size: 14px;
        line-height: 20px;
        min-height: 40px;
    }
    .p_title1{
        color: #999;
        line-height: 13px;
        margin-top: 7px;
    }
    .p_sellnum {
        float: left;
        color: #999;
        margin-top: 14px;
    }
    .p_oprice {
        float: right;
        color: #999;
        font-size: 12px;
        text-decoration: line-through;
        margin-top: 6px;
    }
    .p_price {
        float: right;
        color: #EE3531;
        font-size: 18px;
        font-weight: 600;
        margin-right: 5px;
    }
</style>